import { useState } from "react";

const activities = [
  { icon: "ri-flashlight-line", color: "text-amber-400", company: "上海智联科技有限公司", type: "扩产意向", desc: "计划新增2条生产线，预计投资额8000万元", time: "10分钟前" },
  { icon: "ri-global-line", color: "text-blue-400", company: "杭州云创科技有限公司", type: "投资布局", desc: "在华东区域新注册3家子公司，关注园区A区", time: "35分钟前" },
  { icon: "ri-line-chart-line", color: "text-emerald-400", company: "深圳未来科技有限公司", type: "经营增长", desc: "Q3营收同比增长42%，人员扩招至350人", time: "1小时前" },
  { icon: "ri-patent-line", color: "text-violet-400", company: "北京数智科技有限公司", type: "专利新增", desc: "本月新增发明专利12项，技术实力评级提升", time: "2小时前" },
  { icon: "ri-coin-line", color: "text-amber-500", company: "江苏智造科技有限公司", type: "融资动态", desc: "完成B轮融资2亿元，估值达15亿元", time: "3小时前" },
];

const riskWarnings = [
  { company: "南京星辰信息技术有限公司", level: "高危", risk: "92%", color: "text-rose-400", bg: "bg-rose-400/10 border-rose-400/30" },
  { company: "江苏智造科技有限公司", level: "中危", risk: "68%", color: "text-amber-400", bg: "bg-amber-400/10 border-amber-400/30" },
  { company: "云启数字科技有限公司", level: "中危", risk: "55%", color: "text-amber-400", bg: "bg-amber-400/10 border-amber-400/30" },
  { company: "启迪创新孵化器", level: "低危", risk: "38%", color: "text-blue-400", bg: "bg-blue-400/10 border-blue-400/30" },
];

export default function IMEnterprise() {
  const [tab, setTab] = useState("动态监测");
  const tabs = ["动态监测", "流失预警"];

  return (
    <section className="py-20 px-8" style={{ background: "#f5f4fb" }}>
      <div className="max-w-7xl mx-auto">
        {/* Section title */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-semibold text-indigo-600 tracking-widest uppercase mb-2 block">Enterprise Monitor</span>
            <h2 className="text-3xl font-bold text-slate-800">企业动态监测与流失预警</h2>
            <p className="text-slate-500 text-sm mt-1">实时追踪企业经营动态，提前识别流失风险，保障招商项目稳定落地</p>
          </div>
          <div className="flex gap-1 bg-slate-100 rounded-xl p-1">
            {tabs.map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  tab === t ? "bg-white text-blue-700 shadow-sm font-semibold" : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {/* Left: Overview stats + Risk stats */}
          <div className="flex flex-col gap-4">
            {/* Overview */}
            <div className="bg-gradient-to-br from-[#0a1e3a] to-[#0d2a4a] rounded-2xl p-5 text-white">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-pulse-line text-blue-300 text-sm"></i>
                <span className="text-white/80 text-xs font-medium">今日监测概览</span>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { label: "监测企业", value: "1,256", color: "text-blue-300" },
                  { label: "新增动态", value: "23", color: "text-blue-300" },
                  { label: "风险预警", value: "8", color: "text-rose-300" },
                  { label: "已处置", value: "5", color: "text-emerald-300" },
                ].map((s) => (
                  <div key={s.label} className="bg-white/10 rounded-xl p-3">
                    <div className={`text-xl font-bold ${s.color}`}>{s.value}</div>
                    <div className="text-white/50 text-xs mt-0.5">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Risk warning stats */}
            <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100 flex-1">
              <h4 className="text-slate-700 font-semibold text-sm mb-3">风险预警统计</h4>
              <div className="space-y-3 mb-4">
                {[
                  { level: "高危预警", count: "2", color: "text-rose-500", bar: "bg-rose-400", pct: 100 },
                  { level: "中危预警", count: "2", color: "text-amber-500", bar: "bg-amber-400", pct: 66 },
                  { level: "低危预警", count: "1", color: "text-blue-500", bar: "bg-blue-400", pct: 33 },
                ].map((item) => (
                  <div key={item.level} className="flex items-center gap-2">
                    <span className={`text-xs w-16 ${item.color}`}>{item.level}</span>
                    <div className="flex-1 bg-slate-200 rounded-full h-2">
                      <div className={`${item.bar} rounded-full h-2`} style={{ width: `${item.pct}%` }}></div>
                    </div>
                    <span className="text-slate-500 text-xs font-medium">{item.count} 个</span>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-3 gap-3 pt-4 border-t border-slate-200">
                <div className="bg-emerald-50 rounded-xl px-3 py-3 text-center">
                  <div className="text-lg font-bold text-emerald-600">3</div>
                  <div className="text-emerald-600/60 text-xs">已处置</div>
                </div>
                <div className="bg-blue-50 rounded-xl px-3 py-3 text-center">
                  <div className="text-lg font-bold text-blue-600">2.3h</div>
                  <div className="text-blue-600/60 text-xs">平均响应</div>
                </div>
                <div className="bg-indigo-50 rounded-xl px-3 py-3 text-center">
                  <div className="text-lg font-bold text-indigo-600">92%</div>
                  <div className="text-indigo-600/60 text-xs">处置率</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Activity feed */}
          <div className="col-span-2 bg-slate-50 rounded-2xl border border-slate-100 overflow-hidden flex flex-col">
            <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
              <span className="font-semibold text-slate-700 text-sm">
                {tab === "动态监测" ? "企业动态监测" : "流失风险预警"}
              </span>
              <span className="text-xs text-slate-400">
                {tab === "动态监测" ? "5 条新动态" : "4 条预警"}
              </span>
            </div>
            <div className="divide-y divide-slate-100 flex-1">
              {tab === "动态监测" ? (
                activities.map((a) => (
                  <div key={a.company + a.time} className="px-5 py-4 hover:bg-white transition-colors cursor-pointer">
                    <div className="flex items-start gap-3">
                      <div className={`w-8 h-8 rounded-lg flex items-center justify-center bg-slate-100 flex-shrink-0 ${a.color}`}>
                        <i className={`${a.icon} text-sm`}></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="text-slate-800 text-sm font-medium">{a.company}</span>
                          <span className="text-xs bg-indigo-50 text-indigo-600 border border-indigo-100 px-2 py-0.5 rounded-full">{a.type}</span>
                        </div>
                        <p className="text-slate-500 text-xs mt-1">{a.desc}</p>
                      </div>
                      <span className="text-xs text-slate-400 flex-shrink-0 whitespace-nowrap">
                        <i className="ri-time-line mr-1"></i>{a.time}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                riskWarnings.map((w) => (
                  <div key={w.company} className="px-5 py-4 hover:bg-white transition-colors cursor-pointer">
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${w.bg} border`}>
                        <i className="ri-alarm-warning-line text-lg" style={{ color: w.color === "text-rose-400" ? "#f87171" : w.color === "text-amber-400" ? "#fbbf24" : "#22d3ee" }}></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <span className="text-slate-800 text-sm font-medium">{w.company}</span>
                          <span className={`text-xs font-semibold ${w.color}`}>{w.level}</span>
                        </div>
                        <div className="flex items-center gap-3 mt-1">
                          <span className="text-xs text-slate-400">流失风险 <span className={`font-semibold ${w.color}`}>{w.risk}</span></span>
                        </div>
                      </div>
                      <button className="text-xs bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                        挽留
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
            <div className="px-5 py-3 border-t border-slate-200 bg-white flex items-center justify-between">
              <span className="text-xs text-slate-400">数据实时更新 · 每30秒刷新</span>
              <button className="text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1">
                <i className="ri-external-link-line"></i>查看全部
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
